

































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { scaleLinear } from 'd3-scale'
import { P } from '@/known_blockchains'

@Component({})
export default class StakingTimeline extends Vue {
    @Prop() startTime!: number
    @Prop() endTime!: number
    @Prop() currentTime!: number

    diagramWidth = 250

    get start() {
        return this.scale(this.startTime)
    }

    get current() {
        return this.currentTime > this.endTime
            ? this.scale(this.endTime)
            : this.scale(this.currentTime)
    }

    get stakingDuration() {
        return this.scale(this.endTime) - this.scale(this.startTime)
    }

    get elapsedDuration() {
        const elapsed =
            this.scale(this.currentTime) - this.scale(this.startTime)
        return this.currentTime > this.endTime ? this.stakingDuration : elapsed
    }

    get darkColor() {
        return P.darkColor
    }

    get color() {
        return P.color
    }

    scale(val: number) {
        const scale = scaleLinear()
            .domain([this.startTime, this.endTime])
            .range([0, this.diagramWidth])
        return scale(val)
    }
}
